import { Link } from 'gatsby'
import React from 'react'

export function renderTextWithLink(text, linkClass = 'flat-link--white') {
  return text
    ? text.split(/[{}]/).map(el => {
        if (el.indexOf('|') > -1) {
          const parts = el.split('|')
          return (
            <Link key={parts[0]} className={linkClass} to={parts[1]}>
              {parts[0]}
            </Link>
          )
        }
        return el
      })
    : null
}
